import { useEffect, useState } from 'react';

export function useLoginWatcher() {
  const [loginStatus, setLoginStatus] = useState<'login' | 'logout' | null>(null);

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      // Detect logout signal (written directly to localStorage for cross-tab sync)
      if (event.key === 'logout_signal' && event.newValue) {
        try {
          const parsed = JSON.parse(event.newValue);
          const value = typeof parsed === 'object' && parsed !== null ? parsed.value : parsed;
          if (value === false) {
            setLoginStatus('logout');
          }
        } catch {
          // ignore parse errors
        }
        return;
      }

      // Detect login/logout via zustand auth store changes
      if (event.key === 'auth' && event.newValue) {
        try {
          const parsed = JSON.parse(event.newValue);
          const isLogin = parsed?.state?.isLogin;
          if (isLogin === true) {
            setLoginStatus('login');
          } else if (isLogin === false) {
            setLoginStatus('logout');
          }
        } catch {
          // ignore parse errors
        }
      }
    };

    window.addEventListener('storage', handleStorage);

    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return { loginStatus, setLoginStatus };
}
